import { FC } from 'react';
import { NavLink } from '~/src/components/common-components/nav-link/nav-link';
import { onSendLinkClickAnalytics } from './other-direction-products.analytics';
import { COLORS } from '~/src/styles/tokens/colors';
import type { ProductInterface } from '~/src/models/types/knowledge-base.types';
import * as Styled from './other-direction-products.styles';

interface OtherDirectionProductsProps {
    productGroupName: string | null;
    productList: Array<ProductInterface>;
}

export const OtherDirectionProducts: FC<OtherDirectionProductsProps> = ({ productGroupName, productList }) => {
    return (
        <Styled.OtherDirectionProductsContainer>
            <Styled.ProductGroupNameContainer>
                Другие продукты направления: <Styled.ProductGroupName>{productGroupName}</Styled.ProductGroupName>
            </Styled.ProductGroupNameContainer>
            <Styled.ProductList>
                {productList.map((v) => (
                    <NavLink
                        key={v.order}
                        href={v.sefUrl}
                        linkColor={COLORS.textLightPrimaryLink}
                        textDecoration={'underline'}
                        onClick={() => onSendLinkClickAnalytics(v.name)}
                    >
                        {v.name}
                    </NavLink>
                ))}
            </Styled.ProductList>
        </Styled.OtherDirectionProductsContainer>
    );
};
